"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("relements/build/esm/input/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var text_2 = __importDefault(require("relements/build/esm/ui/text"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
var store_1 = __importDefault(require("@src/store"));
var Slider_1 = __importDefault(require("@src/components/Slider"));
var hasOwn = function (obj, key) {
    return Boolean(obj) && Object.prototype.hasOwnProperty.call(obj, key);
};
var getStoredValue = function (draft, key) {
    if (!draft || !key)
        return undefined;
    if (hasOwn(draft, key) && draft[key] !== undefined && draft[key] !== null) {
        return draft[key];
    }
    var nestedSettings = draft === null || draft === void 0 ? void 0 : draft.agentSettings;
    if (nestedSettings &&
        hasOwn(nestedSettings, key) &&
        nestedSettings[key] !== undefined &&
        nestedSettings[key] !== null) {
        return nestedSettings[key];
    }
    return undefined;
};
var isVisibleWhenSatisfied = function (draft, visibleWhen) {
    if (!(visibleWhen === null || visibleWhen === void 0 ? void 0 : visibleWhen.field_key) || !Array.isArray(visibleWhen === null || visibleWhen === void 0 ? void 0 : visibleWhen["in"])) {
        return true;
    }
    var value = getStoredValue(draft, visibleWhen.field_key);
    if (value === undefined || value === null) {
        return false;
    }
    return visibleWhen["in"].includes(value);
};
var normalizeOptions = function (options) {
    return (Array.isArray(options) ? options : []).map(function (option) {
        if (typeof option === 'string') {
            return { name: option };
        }
        return option;
    });
};
var VoiceAgentDynamicSettings = function (_a) {
    var dynamicSettings = _a.dynamicSettings, agentSettings = _a.agentSettings, onChange = _a.onChange;
    return (react_1["default"].createElement(box_1["default"], { padding: "0 16px 16px", id: "new-settings", flexDirection: "column", 
        //   width="75%"
        style: { gap: '16px' } }, dynamicSettings === null || dynamicSettings === void 0 ? void 0 : dynamicSettings.map(function (setting) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var key = setting.key, type = setting.type, title = setting.title, infoText = setting.info_text, placeholder = setting.placeholder, visibleWhen = setting.visible_when, disabled = setting.disabled;
        if (!isVisibleWhenSatisfied(agentSettings, visibleWhen)) {
            return null;
        }
        var storedValue = getStoredValue(agentSettings, key);
        var resolvedValue = (_a = storedValue !== null && storedValue !== void 0 ? storedValue : setting["default"]) !== null && _a !== void 0 ? _a : (type === 'toggle' ? false : '');
        var label = (react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center" },
            react_1["default"].createElement(text_2["default"], { color: "black.haptik", variant: "h4.semi-bold" }, title),
            infoText && (react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: infoText, position: "TOP" },
                react_1["default"].createElement(InfoIconV4_1["default"], { size: "small", iconColor: "grey.dark", marginLeft: "4px" })))));
        switch (type) {
            case 'toggle': {
                return (react_1["default"].createElement(box_1["default"], { padding: "0px", alignItems: "center", style: { gap: '8px' } },
                    react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(resolvedValue), onChange: function (value) {
                            onChange(key, value);
                        }, disabled: store_1["default"].isProductionEnv() || disabled, 
                        //   label={label}
                        style: { width: 'max-content' } }),
                    react_1["default"].createElement(text_2["default"], { variant: "h3.semi-bold" }, label)));
            }
            case 'dropdown': {
                return (react_1["default"].createElement(dropdown_1["default"], { themed: true, withSearch: true, options: normalizeOptions(setting.options), className: "bot-properties-input", label: label, disabled: store_1["default"].isProductionEnv() || disabled, placeholder: placeholder, optionKey: "name", searchKeys: ['name'], value: { name: resolvedValue !== null && resolvedValue !== void 0 ? resolvedValue : '' }, onChange: function (value) {
                        onChange(key, value === null || value === void 0 ? void 0 : value.name);
                    } }));
            }
            case 'text': {
                return (react_1["default"].createElement(text_1["default"], { themed: true, multiline: setting.multiline, autoExpand: setting.multiline, maxHeight: setting.maxHeight || setting.max_height, disabled: store_1["default"].isProductionEnv() || disabled, label: label, placeholder: placeholder, className: "bot-properties-input", value: resolvedValue, onChange: function (value) {
                        onChange(key, (value === null || value === void 0 ? void 0 : value.trim()) ? value.trim() : '');
                    } }));
            }
            case 'slider':
            case 'range': {
                return (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '24px' } },
                    label,
                    react_1["default"].createElement(Slider_1["default"], { min: (_b = setting.min) !== null && _b !== void 0 ? _b : 0, max: (_c = setting.max) !== null && _c !== void 0 ? _c : 1, step: (_d = setting.step) !== null && _d !== void 0 ? _d : 0.05, leftLabel: (_e = setting.min_label) !== null && _e !== void 0 ? _e : "" + ((_f = setting.min) !== null && _f !== void 0 ? _f : 0), rightLabel: (_g = setting.max_label) !== null && _g !== void 0 ? _g : "" + ((_h = setting.max) !== null && _h !== void 0 ? _h : 1), labelMarginTop: "-7px", value: (_j = resolvedValue !== null && resolvedValue !== void 0 ? resolvedValue : setting.min) !== null && _j !== void 0 ? _j : 0, onChange: function (e) {
                            onChange(key, parseFloat(e.target.value));
                        }, width: "80%", style: { margin: '0 auto' }, disabled: store_1["default"].isProductionEnv() || disabled })));
            }
            default: {
                return null;
            }
        }
    })));
};
exports["default"] = VoiceAgentDynamicSettings;
